import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [loading, setLoading] = useState(false);
  const forced = user?.must_change_password;

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 8) return toast.error("New password must be at least 8 characters");
    if (nw !== cf) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      await refresh();
      toast.success("Password updated");
      navigate("/");
    } catch (e2) {
      toast.error(apiError(e2.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full panel rounded-sm px-3.5 py-3 text-sm outline-none focus:border-[#C5A059]";

  return (
    <div className="min-h-screen grain flex items-center justify-center px-6 bg-[#0D0D0E] relative z-10">
      <div className="w-full max-w-sm rise">
        <Logo className="h-9 mb-6" />
        <h1 className="font-serif text-3xl mb-1.5">{forced ? "Set your password" : "Change password"}</h1>
        <p className="text-sm text-[#8C867A] mb-6">{forced ? "For your security, please set a new password before continuing." : "Update your account password."}</p>
        <form onSubmit={submit} className="space-y-4">
          <div><label className="eyebrow block mb-2">Current / temporary password</label><input data-testid="cp-current" type="password" value={cur} onChange={(e) => setCur(e.target.value)} className={inputCls} required /></div>
          <div><label className="eyebrow block mb-2">New password</label><input data-testid="cp-new" type="password" value={nw} onChange={(e) => setNw(e.target.value)} className={inputCls} required /></div>
          <div><label className="eyebrow block mb-2">Confirm new password</label><input data-testid="cp-confirm" type="password" value={cf} onChange={(e) => setCf(e.target.value)} className={inputCls} required /></div>
          <button data-testid="cp-submit" disabled={loading} className="btn-brass w-full py-3 rounded-sm text-sm">{loading ? "Saving…" : "Save password"}</button>
        </form>
      </div>
    </div>
  );
}
